<template>
  <div class="research_vehicle mb-4">
    <div v-if="responseData && responseData.length" class="px-4  animated_bottom">
      <!-- <div class="d-flex align-items-center justify-content-center py-2 mb-4">
        <div v-for="(item, index) in responseData" :key="index"
          :class="item.year === selectedModels.year ? 'selected_tab' : ''" :style="{ borderColor: primaryColor }"
          class="mx-2 tab_btn" @click="eachTab(item)">
          {{ item.year }}
        </div>
      </div> -->

      <div v-if="selectedModels && selectedModels.models" :key="selectedModels.year" class="tab_models">
        <VSlickCarousel v-bind="slickOptions">
          <div v-for="(model, index) in selectedModels.models" :key="index" class="p-2">
            <div class="bg-white shadow-sm rounded-box p-3">
              <h5 class="_theme_font_bold">{{ model.linkDesc }}</h5>
              <div><img class="img-fluid" :src="model.imageUrl" alt="" loading="lazy" /></div>
              <div>
                <span :id="'modelBtn' + index" :style="{ border: '1px solid' + primaryColor, color: primaryColor }"
                  class="chat_btn_outline" @click.once="eachModel(model)" @mouseover="changeColor(true, index)"
                  @mouseout="changeColor(false, index)">
                  Explore
                </span>
              </div>
            </div>
          </div>
        </VSlickCarousel>

      </div>
    </div>
  </div>
</template>
<script>

import { ChatWidgetService } from '../../../../Services/ChatWidgetService/ChatWidgetService.js';
// import { mapState } from 'vuex';
import 'v-slick-carousel/style.css';
import { VSlickCarousel } from 'v-slick-carousel';

export default {
  props: {
    responseData: {
      required: true,
      type: Array,
    },
    chatThemeSettings: {
      type: Object,
      required: false,
    }
  },
  data() {
    return {
      selectedModels: {},
      primaryColor: window.primaryColor,
      animatedBottom: false,
      slickOptions: {
        infinite: false,
        groupsToShow: 5,
        groupsToScroll: 1,
        dots: false,
        infiniteLoopOnEdge: true,
      },
    };
  },
  // computed: {
  //   ...mapState({
  //     chatThemeSettings: (state) => {
  //       return state.commonSettings.chatThemeSettings;
  //     },
  //   }),
  // },
  watch: {
    responseData: function (val) {
      if (val && val.length) {
        this.selectedModels = val[0];
      }
    }
  },
  mounted() {
    console.log(this.responseData, 'responseData')
    if (this.responseData?.length) {
      this.selectedModels = this.responseData[0];
    }
    if (this.chatThemeSettings?.primeColor) {
      this.primaryColor = this.chatThemeSettings.primeColor
    }
  },
  components: {
    VSlickCarousel,
  },
  methods: {
    eachTab(item) {
      this.animatedBottom = true;
      this.selectedModels = item;
    },
    changeColor(isHovering, index) {
      if (isHovering) {
        document.querySelector(`#modelBtn${index}`).style.background = this.primaryColor;
        document.querySelector(`#modelBtn${index}`).style.color = "#fff";
      } else {
        document.querySelector(`#modelBtn${index}`).style.background = "#fff";
        document.querySelector(`#modelBtn${index}`).style.color = this.primaryColor;
      }
    },
    eachModel(item) {
      this.$root.$emit('isWaitingForResponseData', true);
      let specialObject = { TvmComponentRequest: item.linkDesc };
      ChatWidgetService.postTvmMessage(item.userResponse, null, item?.submitFlow, item?.submitAction, specialObject);
    }
  },
};
</script>
<style lang="less" scoped>
.chat_btn_outline {
  background: #fff;
  border: 0;
  border-radius: 5px;
  padding: 8px;
  text-transform: uppercase;
  font-size: 0.7vw;
  font-weight: 400;
  display: block;
  width: 100%;
  cursor: pointer;
  text-align: center;
  outline: none;
}
</style>
